export const calculateJobStatus = (status, success) => {
    if (status === 'active' || status === 'removed') {
        return status;
    }
    if (status === 'completed' && success) {
        return 'approved';
    }
    return 'rejected';
};
export const itemHasErrorOrWarning = (errors, errWarnType) => {
    const error = errors.find((err) => err.type === errWarnType);
    if (!error) {
        return { hasError: false, hasWarning: false };
    }
    if (!!error.warning || !!error.suggestion || !!error.warnings) {
        return { hasError: false, hasWarning: true };
    }
    return { hasError: true, hasWarning: false };
};
// values to add to Vault
export var StatusColors;
(function (StatusColors) {
    StatusColors["Warning"] = "#FEC048";
    StatusColors["Approved"] = "#00CC00";
    StatusColors["Rejected"] = "#CC0000";
    StatusColors["NotApplicable"] = "#42424222";
})(StatusColors || (StatusColors = {}));
export const jobHasWarnings = (errors) => {
    return errors.some((err) => !!err.warning || !!err.warnings || !!err.suggestion);
};
export const getAmlMatchedTypes = (amlData) => {
    const matches = amlData.hits?.matches;
    if (!matches || Object.keys(matches).length === 0) {
        return 'None';
    }
    return Object.keys(matches)
        .map((a) => a.toUpperCase())
        .join(', ');
};
export const getAmlCountries = (matchlist) => {
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    return matchlist.hits?.countries?.join(', ') || 'None';
};
export const getAmlMatchlists = (matchlist) => {
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    return matchlist.hits?.aka?.join(', ') || 'None';
};
export const getAmlPoliticalPositions = (matchlist) => {
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    return matchlist.hits?.politicalPositions?.join(', ') || 'None';
};
/*
 * workaround due to https://linear.app/vouched/issue/VOU-3212
 * consider moving when https://github.com/microlinkhq/react-json-view/pull/37 is merged
 */
export const copyHandler = (copy) => {
    navigator.clipboard
        .writeText(JSON.stringify(copy.src, null, '  '))
        .catch(console.error);
};
export const getDOB = (dob) => {
    if (!dob)
        return dob;
    return `${dob.slice(0, 2)}/${dob.slice(2, 4)}/${dob.slice(4)}`;
};
